import { useQuery } from '@tanstack/react-query';

import reportService from './reportService';

import type { CompetencyMatrixReport, CompetencyMatrixReportParams } from '@/types/reports';

import { ReportQueryKey } from '@/constants/QueryKeys';

export const useGetCompetencyMatrixReport = (params: CompetencyMatrixReportParams) => {
    return useQuery<CompetencyMatrixReport>({
        queryKey: [ReportQueryKey.COMPETENCY_MATRIX, params],
        queryFn: () => reportService.getCompetencyMatrix(params),
    });
};
